import { Component, HostListener, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { TranslocoDirective } from '@jsverse/transloco';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';

@Component({
	selector: 'vex-change-group-name',
	imports: [
		MatButton,
		MatIconButton,
		MatDialogActions,
		MatDialogContent,
		MatDialogTitle,
		MatError,
		MatFormField,
		MatIcon,
		MatInput,
		MatLabel,
		ReactiveFormsModule,
		TranslocoDirective,
		CdkDrag,
		CdkDragHandle,
	],
	templateUrl: './change-group-name-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './change-group-name-dialog.component.scss',
})
export class ChangeGroupNameDialogComponent {
	dialogRef = inject<MatDialogRef<ChangeGroupNameDialogComponent>>(MatDialogRef);
	data = inject(MAT_DIALOG_DATA);
	private fb = inject(FormBuilder);

	changeGroupName: FormGroup;
	mandatoryChange: boolean = false;

	constructor() {
		const data = this.data;

		this.changeGroupName = this.fb.group({
			groupName: [data.groupName ?? '', [Validators.required]],
		});
		this.mandatoryChange = data.mandatoryChange ?? false;
	}

	onCancel(): void {
		this.dialogRef.close();
	}

	onSubmit(): void {
		if (this.changeGroupName.valid) {
			// The dialog now returns an object with both profile and role
			this.dialogRef.close({
				changedGroupName: this.changeGroupName.value.groupName,
			});
		}
	}

	get email() {
		return this.changeGroupName.get('email');
	}

	get firstName() {
		return this.changeGroupName.get('firstName');
	}

	get lastName() {
		return this.changeGroupName.get('lastName');
	}

	@HostListener('document:keydown.escape', ['$event'])
	onEscapeKey(event: Event): void {
		event.preventDefault();
		this.onCancel();
	}
}
